module.exports = __webpack_public_path__ + "img/gcr-drapeaux-petit-format.7edb0015.jpg";